import React from 'react';
import Attributes from '../../../components/Attributes';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';

const ASSET_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const AttributesStepAsset = ({
	moduleFieldsBreakdown,
	skipModuleKeys,
	updatedForm,
	setUpdateForm,
	form,
	setForm,
}) => {
	const { open: manageAttributesSettings, setOpen: openManageAttributes } =
		useModal('manageAttributes');

	return (
		<>
			{moduleFieldsBreakdown?.customAttributes
				?.filter((field) => skipModuleKeys.indexOf(field.key) === -1)
				?.map((field) => (
					<>
						<Attributes
							field={field}
							onChange={(index, value, fullValue) => {
								if (value || fullValue) {
									let updatedValue = form[index]?.value;

									if (fullValue) {
										updatedValue = fullValue;
									} else {
										if (updatedValue && Array.isArray(value)) {
											updatedValue = [
												...(Array.isArray(updatedValue)
													? updatedValue
													: [updatedValue]),
												...value,
											];
										} else {
											updatedValue = value;
										}
									}

									setUpdateForm({
										...updatedForm,
										[index]: {
											value: updatedValue,
											fieldId: field.id,
										},
									});
								} else {
									let updated = { ...updatedForm };
									updated[index] = {
										...updated[index],
										value: null,
									};

									setUpdateForm(updated);
								}
							}}
							form={{ ...form, ...updatedForm }}
							updatedForm={updatedForm}
							setForm={setUpdateForm}
							moduleId={ASSET_MODULE_ID}
						/>
					</>
				))}

			{moduleFieldsBreakdown?.customAttributes?.filter(
				(field) => skipModuleKeys.indexOf(field.key) === -1
			)?.length === 0 ? (
				<div className="py-2 transition duration-200 ease-in-out col-span-2">
					<div className="bg-[#f9f8f8] w-full h-full p-10 flex justify-center items-center flex-col gap-4 text-xs">
						<p>You do not have any active custom fields</p>
						<Button
							type="secondary"
							onClick={() => {
								openManageAttributes({
									moduleId: ASSET_MODULE_ID,
									onSelect: (id, active) => {
										onRefreshModuleFields(
											{
												categoryId: form?.category?.value?.value,
											},
											null,
											{ silent: true }
										);
									},
								});
							}}
						>
							Manage Fields
						</Button>
					</div>
				</div>
			) : (
				<div className="text-md col-span-2 mt-4 flex items-center justify-end">
					<Button
						type="ghost"
						onClick={() => {
							openManageAttributes({
								moduleId: ASSET_MODULE_ID,
								onSelect: (id, active) => {
									onRefreshModuleFields(
										{
											categoryId: form?.category?.value?.value,
										},
										null,
										{ silent: true }
									);
								},
							});
						}}
					>
						Manage Fields
					</Button>
				</div>
			)}
		</>
	);
};

export default AttributesStepAsset;
